import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clark-teleporter-destination',
  templateUrl: './teleporter-destination.component.html',
})
export class TeleporterDestinationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
